// Transforms [{name: 'Accept', value: '*/*'}, {name: 'Connection', value: 'keep-alive'}]
// to the more efficient: {'Accept': '*/*', 'Connection': 'keep-alive'};
// Before SDK, the former was the default format; Now, the latter is;
export default function transformRequestHeaderArrayToObject(headerArray) {
	if (!headerArray) return
	if (!Array.isArray(headerArray)) return headerArray
	const headerObject = {}
	for (const {name, value} of headerArray) {
		if (!headerObject[name]) {
			headerObject[name] = value
		} else {
			// Handle multi-value HTTP headers
			headerObject[name] += ', ' + value
		}
	}
	return headerObject
}
